import React, { useState } from 'react';
import EmailForm from './EmailForm';
import { styles } from '../styles';
import ChatAI from './ChatEngine';

const SupportWindow = ({ visible }) => {
  const [user, setUser] = useState(null);

  return (
    <div
      className="transition-5"
      style={{
        ...styles.supportWindow,
        opacity: visible ? '1' : '0',
        display: visible ? 'block' : 'none'
      }}
    >
      {/* Email prompt if no user */}
      <EmailForm visible={user === null} setUser={setUser} />

      {/* ChatAI when user is set */}
      {user && <ChatAI user={user} />}
    </div>
  );
};

export default SupportWindow;
